/* Kintoe toe-sock lander v5: countdown, FAQ animation, reduced-motion video. No dependencies. */
(function () {
  'use strict';

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mq && mq.matches); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var DAY = 86400000;

  /* Countdown. Same logic as the v4 bar (kintoe-pts-bar): count down to the
     anchor time in the visitor's local time; once it has passed, add whole
     days until it is in the future again, so it loops daily. Ticks every second. */
  function parseAnchor(str) {
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?/.exec(String(str || '').trim());
    if (!m) return new Date(2026, 5, 25, 23, 59, 59).getTime();
    return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0)).getTime();
  }

  function initCountdown(el) {
    if (el._l5Timer) clearInterval(el._l5Timer);
    var target = parseAnchor(el.getAttribute('data-anchor'));
    var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'),
        m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    if (!d || !h || !m || !s) return;
    function tick() {
      var now = Date.now();
      while (now >= target) { target += DAY; }
      var x = target - now;
      d.textContent = pad(Math.floor(x / 86400000));
      h.textContent = pad(Math.floor(x % 86400000 / 3600000));
      m.textContent = pad(Math.floor(x % 3600000 / 60000));
      s.textContent = pad(Math.floor(x % 60000 / 1000));
    }
    tick();
    el._l5Timer = setInterval(tick, 1000);
  }

  /* Sticky bar height feeds scroll-padding-top so anchors and focus are never hidden under it. */
  function trackBar(bar) {
    function set() { document.documentElement.style.setProperty('--l5-bar-h', bar.offsetHeight + 'px'); }
    set();
    if (window.ResizeObserver && !bar._l5Ro) { bar._l5Ro = new ResizeObserver(set); bar._l5Ro.observe(bar); }
  }

  /* FAQ: <details> with a height animation on open AND close. On close the
     item keeps [open] until the animation ends, then closes. Clicking again
     mid-animation reverses from the current height. */
  function initFaq(item) {
    if (item._l5Faq) return;
    item._l5Faq = true;
    var summary = item.querySelector('summary');
    var panel = item.querySelector('.l5-faq__panel');
    if (!summary || !panel) return;
    var anim = null;
    item.setAttribute('data-state', item.open ? 'open' : 'closed');
    item.addEventListener('toggle', function () {
      if (!anim) item.setAttribute('data-state', item.open ? 'open' : 'closed');
    });

    summary.addEventListener('click', function (e) {
      var opening = item.getAttribute('data-state') !== 'open';
      if (reduced() || !panel.animate) {
        item.setAttribute('data-state', opening ? 'open' : 'closed');
        return; // native toggle
      }
      e.preventDefault();
      var start = item.open ? panel.getBoundingClientRect().height : 0;
      if (anim) { anim.cancel(); anim = null; }
      item.setAttribute('data-state', opening ? 'open' : 'closed');
      if (opening) item.open = true;
      var end = opening ? panel.scrollHeight : 0;
      var a = panel.animate(
        [{ height: start + 'px' }, { height: end + 'px' }],
        { duration: Math.min(420, 220 + Math.abs(end - start) / 3), easing: 'cubic-bezier(.25,.8,.25,1)', fill: 'forwards' }
      );
      anim = a;
      a.onfinish = function () {
        if (anim !== a) return;
        if (!opening) item.open = false;
        a.cancel();
        anim = null;
      };
    });
  }

  function init(root) {
    root = root || document;
    var bars = root.querySelectorAll('[data-l5-countdown]');
    for (var i = 0; i < bars.length; i++) initCountdown(bars[i]);
    var sticky = root.querySelectorAll('[data-l5-sticky]');
    for (var j = 0; j < sticky.length; j++) trackBar(sticky[j]);
    var faqs = root.querySelectorAll('details.l5-faq__item');
    for (var k = 0; k < faqs.length; k++) initFaq(faqs[k]);
    if (reduced()) {
      var vids = root.querySelectorAll('.l5 video[autoplay]');
      for (var v = 0; v < vids.length; v++) { vids[v].removeAttribute('autoplay'); vids[v].pause(); vids[v].controls = true; }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var bars = e.target.querySelectorAll('[data-l5-countdown]');
    for (var i = 0; i < bars.length; i++) if (bars[i]._l5Timer) clearInterval(bars[i]._l5Timer);
  });
})();

/* Mobile sticky CTA: show after the hero scrolls out, hide when a closing or offer CTA is on screen. */
(function () {
  var btn = document.querySelector('[data-l5-sticky-cta]');
  if (!btn || !('IntersectionObserver' in window)) return;
  btn.hidden = false; btn.classList.add('is-off'); document.body.classList.add('l5-has-sticky');
  var hero = document.querySelector('.l5-hero');
  var ctas = document.querySelectorAll('.l5 .l5-btn');
  var heroGone = false, seen = new Set();
  function sync() { btn.classList.toggle('is-off', !heroGone || seen.size > 0); }
  if (hero) new IntersectionObserver(function (e) { heroGone = !e[0].isIntersecting; sync(); }).observe(hero);
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
    sync();
  });
  ctas.forEach(function (c) { io.observe(c); });
})();
